import { createFileRoute } from "@tanstack/react-router";
import { ChangelogContent } from "@/components/changelog/changelog-content";
import { usePageTitle } from "@/hooks/use-page-title";
import { releaseIndex } from "@/data/changelog";

type ChangelogSearch = {
  version?: string;
};

export const Route = createFileRoute("/dashboard/changelog")({
  validateSearch: (search: Record<string, unknown>): ChangelogSearch => ({
    version: (search.version as string) || undefined,
  }),
  component: ChangelogPage,
});

function ChangelogPage() {
  usePageTitle("Changelog");
  const { version } = Route.useSearch();
  const selectedVersion = version || releaseIndex[0]?.version;

  return <ChangelogContent selectedVersion={selectedVersion} />;
}
